export default __webpack_public_path__ + "static/media/Vector (13).c84a7c0d.svg";